import clsx from "clsx";
import { Tooltip } from 'react-tooltip';

interface ActionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  warning?: boolean;
  action?: boolean;
  label?: string;
  tooltip?: string | undefined;
  onClick?: () => Promise<void>;
}

const ActionButton = ({
  children,
  className,
  label,
  tooltip,
  onClick,
  warning,
  action,
  ...rest
}: ActionButtonProps) => (
  <div
      className={clsx("action-button", className, {
        "action-button-warning": warning,
        "action-button-action": action,
      })}
    >
    <button {...rest} onClick={onClick}>
    {children}
    </button>
    <div 
        data-tooltip-id="tooltip-button"
        data-tooltip-content={tooltip}
        data-tooltip-place='bottom'
      >
      <Tooltip id="tooltip-button"  />
      <strong>{label}</strong>
    </div>
  </div>
);

export default ActionButton;
